// Marca los chats de WhatsApp que vienen de un anuncio de Google.
// Google Ads añade ?gclid= (o gbraid/wbraid) a la URL de llegada; lo guardamos
// durante la sesión y añadimos una frase al mensaje prellenado de cada enlace
// de WhatsApp, para que en la tienda se vea de dónde viene el contacto.

const CLAVE = 'proomtb_origen';
const FRASE = 'Vi su anuncio en Google.';
// Conversión "WhatsApp clic (etiqueta Google Ads)" en la cuenta de Google Ads 470-829-7327.
const CONVERSION_WHATSAPP = 'AW-17688756283/dY-fCKCf6qUdELuA1PJB';

function detectarOrigen() {
    try {
        const params = new URLSearchParams(window.location.search);
        const esAnuncio = params.has('gclid') || params.has('gbraid') || params.has('wbraid')
            || (params.get('utm_source') === 'google' && params.get('utm_medium') === 'cpc');
        if (esAnuncio) sessionStorage.setItem(CLAVE, 'google-ads');
    } catch (e) {
        // sin sessionStorage (modo privado estricto): no se marca nada
    }
}

export function vieneDeAnuncio() {
    try {
        return sessionStorage.getItem(CLAVE) === 'google-ads';
    } catch (e) {
        return false;
    }
}

// Avisa a Google Ads de un contacto por WhatsApp. Google solo lo cuenta si la visita vino de un anuncio.
export function registrarContactoWhatsApp() {
    try {
        if (typeof window.gtag === 'function') window.gtag('event', 'conversion', { send_to: CONVERSION_WHATSAPP });
    } catch (e) {
        // sin gtag (bloqueador de anuncios): no se mide, el enlace funciona igual
    }
}

// Devuelve la misma URL de WhatsApp con la frase añadida al texto prellenado.
export function conOrigen(url) {
    if (!vieneDeAnuncio()) return url;
    try {
        const u = new URL(url);
        if (!/wa\.me|whatsapp\.com/.test(u.hostname)) return url;
        const texto = (u.searchParams.get('text') || 'Hola!').trim();
        if (texto.includes(FRASE)) return url;
        // Se codifica a mano (%20) porque wa.me no siempre interpreta el "+" como espacio.
        u.searchParams.delete('text');
        const resto = u.searchParams.toString();
        return `${u.origin}${u.pathname}?${resto ? resto + '&' : ''}text=${encodeURIComponent(`${texto} ${FRASE}`)}`;
    } catch (e) {
        return url;
    }
}

// Cubre todos los enlaces <a href="https://wa.me/..."> del sitio sin tocarlos uno a uno.
function marcarEnlaces(event) {
    const enlace = event.target.closest && event.target.closest('a[href]');
    if (!enlace) return;
    const href = enlace.getAttribute('href') || '';
    if (!/wa\.me|whatsapp\.com/.test(href)) return;
    registrarContactoWhatsApp();
    const nuevo = conOrigen(enlace.href);
    if (nuevo !== enlace.href) enlace.href = nuevo;
}

export function iniciarOrigenAnuncios() {
    if (typeof window === 'undefined') return;
    detectarOrigen();
    document.addEventListener('click', marcarEnlaces, true);
}
